import { SubPageSectionHeading } from "./SectionContent";

function BridgeWorks() {
  return (
    // <section className='py-[120px]'>
    //      <h2
    //     style={{
    //       fontFamily: "Akira Expanded",
    //       fontWeight: 700,
    //       fontSize: "clamp(1.75rem, 5vw, 2.5rem)", // ~28px to 40px
    //       lineHeight: "100%",
    //       letterSpacing: "-0.05em", // -5%
    //       textTransform: "uppercase",
    //     }}
    //     className="w-full max-w-[763px] gradient-text bg-left-bottom bg-textGd mb-[20px] overflow-hidden text-ellipsis text-black"
    //   >
    //     How does it work?
    //   </h2>
    //     <div className='grid md:grid-cols-2 gap-6'>
    //         <div className='col-span-1'>
    //             <div className='rounded-2xl backdrop-blur-[10px] border-[1.5px] border-white/10 h-full overflow-hidden'>
    //                 <img
    //                     src={`${process.env.REACT_APP_S3_ASSETS_URL}bridgeWorks.png`}
    //                     alt="Bridge img"
    //                     className="w-full h-full object-cover xl:max-w-[400px] mx-auto"
    //                 />
    //             </div>
    //         </div>
    //         <div className='col-span-1 space-y-[14px] flex flex-col'>
    //             <div className="flex justify-between flex-col gap-3 md:gap-5 bg-white/[0.03] rounded-2xl border-[1.5px] border-white/[0.10] backdrop-blur-[10px] h-full p-6">
    //                 <div className='flex items-center justify-between'>
    //                     <span
    //                         className="w-[56px] h-[56px] rounded-xl icon-gradient flex items-center justify-center *:w-full *:h-full *:max-w-[70%] *:md:max-w-[50%] duration-300"
    //                     >
    //                         {generalIcons.decentralizedToken}
    //                     </span>
    //                     <span
    //                         className="w-10 h-10 md:w-[70px] md:h-[56px] flex items-center justify-center *:w-full *:h-full duration-300"
    //                     >
    //                         {generalIcons.one}
    //                     </span>
    //                 </div>
    //                 <div className="space-y-3">
    //                     <h3 className="text-base md:text-[24px]/6 font-semibold text-dim -tracking-[0.96px]">
    //                         Decentralized Token Swaps
    //                     </h3>
    //                     <p className="text-xsm md:text-sm/6 -tracking-[0.8px] text-dim opacity-[0.84]">
    //                         The Router Nitro Bridge allows secure, decentralized token swaps across chains.
    //                     </p>
    //                 </div>
    //             </div>
    //             <div className="flex justify-between flex-col gap-3 md:gap-5 bg-white/[0.03] rounded-2xl border-[1.5px] border-white/[0.10] backdrop-blur-[10px] h-full p-6">
    //                 <div className='flex items-center justify-between'>
    //                     <span
    //                         className="w-[56px] h-[56px] rounded-xl icon-gradient flex items-center justify-center *:w-full *:h-full *:max-w-[70%] *:md:max-w-[50%] duration-300"
    //                     >
    //                         {generalIcons.realTimeToken}
    //                     </span>
    //                     <span
    //                         className="w-10 h-10 md:w-[80px] md:h-[56px] flex items-center justify-center *:w-full *:h-full duration-300"
    //                     >
    //                         {generalIcons.two}
    //                     </span>
    //                 </div>
    //                 <div className="space-y-3">
    //                     <h3 className="text-base md:text-[24px]/6 font-semibold text-dim -tracking-[0.96px]">
    //                         Real-Time Token Conversion to $VANRY
    //                     </h3>
    //                     <p className="text-xsm md:text-sm/6 -tracking-[0.8px] text-dim opacity-[0.84]">
    //                         Convert ETH or other supported tokens into $VANRY on the Vanar blockchain in real time.
    //                     </p>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // </section>
    <section className="relative py-6 lg:py-12">
      <SubPageSectionHeading className="mb-4 lg:mb-8 text-center">
        How the bridge works
      </SubPageSectionHeading>
      <div className="grid lg:grid-cols-2 gap-4 lg:gap-7">
        {/* <div className="col-span-1">
          <div className="benefitcard relative flex flex-col items-start gap-3 lg:min-h-[236px] h-full bg-black/5  hoverCardTop duration-300 overflow-hidden">
            <img
              src={`${process.env.REACT_APP_S3_ASSETS_URL}neutron-coins.jpg`}
              alt="Bridge img"
              className="size-full object-center"
            />
          </div>
        </div> */}
        <div className="col-span-1 space-y-4 lg:space-y-7 flex flex-col">
          <div className="flex justify-between md:gap-5 benefitcard relative  flex-col h-full items-start gap-3 lg:min-h-[280px] p-6 lg:p-8 bg-white hoverCardTop hover:!bg-[#1B2129] hover:!text-white group gap-5w-full duration-300 bg-CardBG bg-no-repeat bg-cover bg-right-bottom before:absolute before:bg-contain hover:before:bg-[#1B2129]/80 before:bg-no-repeat before:bg-right-bottom before:bg-yellowDotBg before:bottom-0 before:h-full before:right-0 before:w-full before:z-[-1]">
            {/* Top Right Icon */}
            {/* <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div> */}
            {/* Bottom Right Icon */}
            {/* <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div> */}
            <div className="flex items-center justify-between">
              <span className="w-[68px] h-[68px]  icon-gradient flex items-center  justify-center *:w-full *:h-full  duration-300">
                <img
                  src={`${process.env.REACT_APP_S3_ASSETS_URL}decentralized-image.png`}
                  alt="Decentralized"
                  className="w-full h-full object-cover xl:max-w-[400px] mx-auto"
                />
              </span>
            </div>
            <div className="space-y-3 ">
              <h3
                style={{
                  fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white max-w-[390px]
                       "
              >
                Decentralized Token Swaps
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white">
                The Router Nitro Bridge allows secure, decentralized token swaps
                across chains.
              </p>
            </div>
          </div>
          
        </div>

        <div className="col-span-1 space-y-4 lg:space-y-7 flex flex-col">
        <div className="flex justify-between md:gap-5 benefitcard relative  flex-col h-full items-start gap-3 lg:min-h-[280px] p-6 lg:p-8 bg-white hoverCardTop hover:!bg-[#1B2129] hover:!text-white group gap-5w-full duration-300 bg-CardBG bg-no-repeat bg-cover bg-right-bottom before:absolute before:bg-contain hover:before:bg-[#1B2129]/80 before:bg-no-repeat before:bg-right-bottom before:bg-yellowDotBg before:bottom-0 before:h-full before:right-0 before:w-full before:z-[-1]">
            {/* Top Right Icon */}
            {/* <div className="absolute top-3 right-4 size-3 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12 14L12 2L0 2"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div> */}

            {/* Bottom Right Icon */}
            {/* <div className="absolute bottom-3 right-4 size-2 *:size-full text-green group-hover:text-white">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
              >
                <path
                  d="M8 0L8 8L0 8"
                  stroke="currentColor"
                  strokeWidth="2.5"
                />
              </svg>
            </div> */}

            <div className="flex items-center justify-between">
              <span className="w-[68px] h-[68px]  icon-gradient flex items-center justify-center *:w-full *:h-full  duration-300">
                <img
                  src={`${process.env.REACT_APP_S3_ASSETS_URL}real-time-token-img.png`}
                  alt=""
                  className="w-full h-full object-cover xl:max-w-[400px] mx-auto"
                />
              </span>
            </div>
            <div className="space-y-3 ">
              <h3
                style={{
                  fontSize: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                  lineHeight: "clamp(1.25rem, 1.2rem + 0.25vw, 1.5rem)",
                }}
                className="font-bold uppercase font-sans tracking-[-1.2px] text-gunMetal group-hover:text-white"
              >
                <>
                  Real-Time Token Conversion <br />
                  to $VANRY
                </>
              </h3>
              <p className="text-gunMetal text-[12px]/[16px] lg:text-[16px]/[24px] font-medium font-serif group-hover:text-white">
                Convert ETH or other supported tokens into $VANRY on the Vanar
                blockchain in real time.
              </p>
            </div>
          </div>
        </div>
        
      </div>
    </section>
  );
}

export default BridgeWorks;
